import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { assignValueById } from 'utils/Activities/activitiesRemoveDuplicates';
import { useSchool } from '../../SchoolContext';
import { getActivityData } from '../../utils';
import ProfileSection from '../ProfileSection';
import styles from './styles.module.css';
import renderListOfActivitiesTypes from '../utils/renderListOfActivitiesTypes';

export default function SecuritiesActivities({ isFetching }) {
  const { schoolData } = useSchool();
  const activities = getActivityData(schoolData || []) || [];
  const [useAllactivities, setUseAllActivities] = useState([]);
  const [securitiesActivities, setSecuritiesActivities] = useState({});
  const [count, setCount] = useState(0);

  useEffect(() => {
    const loadActivities = async () => {
      if (!activities.length) return;

      const covid19Activities = {
        properties: await assignValueById(activities, 20),
        title: 'Medidas Covid-19',
      };
      const otherSecuritiesActivities = {
        properties: await assignValueById(activities, 21),
        title: 'Otras Medidas de Seguridad',
      };

      const securityActv = await assignValueById(activities, 19);
      setSecuritiesActivities(securityActv);

      if (covid19Activities.length === 0
        && otherSecuritiesActivities.length === 0
      ) {
        setUseAllActivities(null);
      } else {
        setUseAllActivities([
          covid19Activities,
          otherSecuritiesActivities,
        ]);
      }
    };

    loadActivities();
  }, [activities]);

  useEffect(() => {
    if (!useAllactivities) return;
    setCount(0); // Reset count before recounting
    useAllactivities.forEach((activity) => {
      if (activity.properties.length > 0) {
        setCount((prevCount) => prevCount + 1);
      }
    });
  }, [useAllactivities]);

  if (isFetching) {
    return <>...loading</>;
  }

  if (!count) {
    return <>{' '}</>;
  }

  return (
    <ProfileSection
      title="Medidas de Seguridad"
      subtitleLyrics={{
        subtitle: '',
        lyrics: securitiesActivities[0]?.description,
      }}
    >
      <div className={styles.sectionsContainer}>
        {renderListOfActivitiesTypes(useAllactivities)}
      </div>
    </ProfileSection>
  );
}

SecuritiesActivities.propTypes = {
  isFetching: PropTypes.bool.isRequired,
};
